module.exports = __webpack_public_path__ + "media/images/icons/icon-ramsey-5f796af2677d5c6882757fa3169c3bbc.svg";